module.exports = __webpack_public_path__ + "static/media/use_brinq_prepaid_card.54af52da.png";